module.exports = __webpack_public_path__ + "8ca17d735bc56579a6e1577acbd31b29.ttf";